import { config } from '../config';
import SessionService from './SessionService';

export interface InternalGroup {
    id: number;
    name: string;
    sector_id: number;
    created_at?: string;
    updated_at?: string;
}

export const getInternalGroups = async (sectorId: number) => {
    const token = SessionService.getToken();
    const response = await fetch(`${config.WHATSAPP_API_URL}/internal-groups?sector_id=${sectorId}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to fetch groups');
    return await response.json(); // Returns APIResponse with data
};

export const createInternalGroup = async (name: string, sectorId: number) => {
    const token = SessionService.getToken();
    const response = await fetch(`${config.WHATSAPP_API_URL}/internal-groups`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name, sector_id: sectorId })
    });
    if (!response.ok) throw new Error('Failed to create group');
    return await response.json();
};

export const deleteInternalGroup = async (groupId: number) => {
    const token = SessionService.getToken();
    const response = await fetch(`${config.WHATSAPP_API_URL}/internal-groups/${groupId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to delete group');
    return await response.json();
};

export const addContactToGroup = async (groupId: number, contactId: number) => {
    const token = SessionService.getToken();
    const response = await fetch(`${config.WHATSAPP_API_URL}/internal-groups/${groupId}/contacts`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ contact_id: contactId })
    });
    if (!response.ok) throw new Error('Failed to add contact to group');
    return await response.json();
};

export const removeContactFromGroup = async (groupId: number, contactId: number) => {
    const token = SessionService.getToken();
    const response = await fetch(`${config.WHATSAPP_API_URL}/internal-groups/${groupId}/contacts/${contactId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to remove contact from group');
    return await response.json();
};

export const getContactsInGroup = async (groupId: number) => {
    const token = SessionService.getToken();
    const response = await fetch(`${config.WHATSAPP_API_URL}/internal-groups/${groupId}/contacts`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to fetch group contacts');
    return await response.json();
};

export const getGroupsForContact = async (contactId: number) => {
    const token = SessionService.getToken();
    const response = await fetch(`${config.WHATSAPP_API_URL}/contacts/${contactId}/internal-groups`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to fetch contact groups');
    return await response.json();
};
